"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLocationFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2C9.46 2 6 5.61 6 12.45c0 8.61 8.94 16.93 9.32 17.28l.68.62.68-.62c.38-.35 9.32-8.67 9.32-17.28C26 5.61 22.54 2 16 2zm4.5 10.5A4.5 4.5 0 1116 8a4.51 4.51 0 014.5 4.5z" })));
}
exports.default = SvgLocationFilled;
//# sourceMappingURL=LocationFilled.js.map